export const GET_MAP_LOCATION = "getMapLocation"
export const GET_LOCATION_INFO = "getLocationInfo"

export default {
  [GET_MAP_LOCATION]: (state: LocationState): MapLocation[] => state.locationPins,
  [GET_LOCATION_INFO]: (state: LocationState): LocationInfo => state.locationInfo
}
